if (!customElements.get('gift-message-form')) {
  customElements.define(
    'gift-message-form',
    class GiftMessageForm extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const from = this.querySelector('[data-gift-from]');
            const to = this.querySelector('[data-gift-to]');
            const message = this.querySelector('[data-gift-message]');

            const body = JSON.stringify({
              attributes: {
                'رسالة الإهداء - من': from ? from.value : '',
                'رسالة الإهداء - إلى': to ? to.value : '',
                'رسالة الإهداء': message ? message.value : '',
              },
            });

            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then(() => {
              if (window.CartPerformance && typeof CartPerformance.measureFromEvent === 'function') {
                CartPerformance.measureFromEvent('gift-message-update:user-action', event);
              }
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
